import axios from "axios";

export const AI_BASE_URL = process.env.REACT_APP_AI_BASE_URL;

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/`,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    "Ocp-Apim-Subscription-Key": process.env.REACT_APP_API_KEY ?? "",
  },
});

console.log("process.env.REACT_APP_API_BASE_URL", process.env.REACT_APP_API_BASE_URL)
console.log("process.env.REACT_APP_AI_BASE_URL", process.env.REACT_APP_AI_BASE_URL)

api.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("token");

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized");
    }
    return Promise.reject(error);
  }
);

export default api;
